export default "__VITE_PUBLIC_ASSET__f8556579__"